var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "generic-route h-v100" }, [
    _c("div", { staticClass: "body" }, [
      _c("h1", [_vm._v(_vm._s(_vm.$t("general.pageNotFound")))]),
      _c("h2", [_vm._v(_vm._s(_vm.$t("general.error404")))]),
      _c("div", { staticClass: "image" }),
      _c("a", { attrs: { href: "/" } }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("general.goBackToHome")))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }